<template>

  <div>
    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :blank-user-data="blankUserData"
      :grupos-options="gruposOptions"
      :plan-options="gruposOptions"
      @refetch-data="refetchData"
      @update:grupoFilter="grupoFilter = $event"
      @input="showAddEditUsuario"
    />

    <!-- Filters -->
    <!-- <users-list-filters
      :role-filter.sync="roleFilter"
      :grupo-filter.sync="grupoFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :grupo-options="gruposOptions"
      :status-options="statusOptions"
      @statusFilter="updatedStatusFilter"
    /> -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                v-if="$can('create', 'Padrinho')"
                variant="primary"
                @click="showConviteModal()"
              >
                <span class="text-nowrap">
                  <feather-icon
                    class="cursor-pointer"
                    icon="PlusIcon"
                    size="16"
                  />
                  Convidar
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Client -->
        <template #cell(client)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.cliente.nome)"
                :variant="`light-primary`"
              />
            </template>
            <span class="font-weight-bold d-block text-nowrap">
              <router-link
                :to="{ name: 'app-admin-view-cliente', params: { id: data.item.cliente.id }}"
                class="text-body"
              >{{ data.item.cliente.nome }}</router-link>
            </span>
          </b-media>
        </template>

        <!-- Column: User -->
        <template #cell(nome_usuario)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.nome_usuario)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.nome_usuario }}
            </b-link>
            <small class="text-muted">@{{ data.item.email_usuario }}</small>
          </b-media>
        </template>

        <!-- Column: Data Criaçaõ -->
        <template #cell(data_inclusao)="data">
          <div class="text-nowrap">
            <span>{{ data.item.data_inclusao | formatDateTimeBr }}</span>
          </div>
        </template>

        <!-- Column: Data Criaçaõ -->
        <template #cell(data_alteracao)="data">
          <div class="text-nowrap">
            <span>{{ data.item.data_alteracao | formatDateTimeBr }}</span>
          </div>
        </template>

        <!-- Column: Role -->
        <template #cell(id_grupousuario)="data">
          <div class="text-nowrap">
            <feather-icon
              v-if="data.item.grupo"
              :icon="resolveUserRoleIcon(data.item.grupo ? data.item.grupo.grupousuario : '')"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.grupo ? data.item.grupo.grupousuario : '')}`"
            />
            <span class="align-text-top text-capitalize">{{
              data.item.grupo ? data.item.grupo.grupousuario : ''
            }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <b-modal
      id="modal-convite"
      title="Links de Convite"
      hide-footer
      size="md"
      centered
      body-class="p-0"
    >
      <div class="p-4">
        <div class="text-center mb-4">
          <div class="d-inline-flex align-items-center justify-content-center bg-light-primary rounded-circle mb-3" style="width: 60px; height: 60px;">
            <feather-icon icon="UserPlusIcon" size="24" class="text-primary" />
          </div>
          <h5 class="mb-1">Convidar Novos Usuários</h5>
          <p class="text-muted mb-0">Compartilhe os links abaixo para convidar novos membros</p>
        </div>

        <div class="space-y-3">

          <b-card class="border-0 shadow-sm mb-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center justify-content-center bg-light-success rounded-circle mr-3" style="width: 40px; height: 40px;">
                  <feather-icon icon="TrendingUpIcon" size="18" class="text-success" />
                </div>
                <div>
                  <h6 class="mb-0">Convite para Afiliado</h6>
                  <small class="text-muted">Link para cadastro de afiliados</small>
                </div>
              </div>
              <b-button 
                variant="outline-success" 
                size="sm" 
                @click="copyToClipboard(linkAfiliado)"
                class="d-flex align-items-center"
              >
                <feather-icon icon="CopyIcon" size="14" class="mr-1" />
                Copiar
              </b-button>
            </div>
          </b-card>

          <b-card class="border-0 shadow-sm mb-4">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center justify-content-center bg-light-info rounded-circle mr-3" style="width: 40px; height: 40px;">
                  <feather-icon icon="ShoppingBagIcon" size="18" class="text-info" />
                </div>
                <div>
                  <h6 class="mb-0">Convite para Vendedor</h6>
                  <small class="text-muted">Link para cadastro de vendedores</small>
                </div>
              </div>
              <b-button 
                variant="outline-info" 
                size="sm" 
                @click="copyToClipboard(linkVendedor)"
                class="d-flex align-items-center"
              >
                <feather-icon icon="CopyIcon" size="14" class="mr-1" />
                Copiar
              </b-button>
            </div>
          </b-card>
        </div>

        <div class="text-center">
          <b-button 
            variant="secondary" 
            @click="$bvModal.hide('modal-convite')"
            class="px-4"
          >
            Fechar
          </b-button>
        </div>
      </div>
    </b-modal>

    <ModalConfirm
      id-modal="modal-confirme-delete-user"
      title-modal="Excluir Usuário"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir o usuário?"
      @ok="deletedUser"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBModal, VBTooltip, BModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { getUserData } from '@/auth/utils'
import {
  ref, onUnmounted, onMounted, getCurrentInstance,
} from '@vue/composition-api'
import { avatarText, formatDateTimeBr } from '@core/utils/filter'
import { deletedUsuarioById } from '@/services/usuarioService'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import UsersListFilters from './UsersListFilters.vue'
import useAbilityList from './useUsersListApadrinhado'
import userStoreModule from '../userStoreModule'
import UserListAddNew from './UserListAddNew.vue'

export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    ModalConfirm,
    vSelect,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  filters: {
    formatDateTimeBr,
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const USER_APP_STORE_MODULE_NAME = 'app-adm-usuarios'
    const userData = getUserData()
    const userId = userData.id
    const idUsuario = ref(null)
    const blankUserData = ref({
      id: null,
      nome_cliente: '',
      id_cliente: null,
      login: '',
      senha: null,
      ativo: 1,
      id_grupousuario: null,
    })

    const {
      fetchUsers,
      fetchPadrinhoByUserId,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
    } = useAbilityList()

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)
    const gruposOptions = ref([])

    const updatedStatusFilter = e => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchUsers`)
    }
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addUsuario = async () => {
      blankUserData.value = {
        id: null,
        nome_cliente: '',
        id_cliente: null,
        login: '',
        senha: null,
        ativo: 1,
        id_grupousuario: null,
      }
      isAddNewUserSidebarActive.value = true
    }

    const getRegisterBaseUrl = () => {
      const mode = process.env.MODE_APP
      if (mode === 'prod') {
        return 'https://admin.avmarket.com.br/register'
      }
      return 'https://admin.hml.avmarket.com.br/register'
    }

    const deletedUser = async () => {
      if (idUsuario.value === null) return
      await deletedUsuarioById(idUsuario.value)
        .then(() => {
          idUsuario.value = null
          refetchData()
        })
      refetchData()
    }

    const editarUsuario = async id_usuario => {
      await store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchUser`, { id: id_usuario })
        .then(data => {
          blankUserData.value = data.data
          blankUserData.value.id_grupousuario = data.data.grupo
          blankUserData.value.nome_cliente = data.data.cliente.nome
          isAddNewUserSidebarActive.value = true
        })
    }

    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ]

    const statusOptions = [
      { label: 'Todos', value: '' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const linkAfiliado = ref('')
    const linkVendedor = ref('')

    const showConviteModal = async () => {
      try {
        const response = await fetchPadrinhoByUserId(userId)
        linkAfiliado.value = `${getRegisterBaseUrl()}?code=${response.codigo}&group=4`
        linkVendedor.value = `${getRegisterBaseUrl()}?code=${response.codigo}&group=5`
        proxy.$bvModal.show('modal-convite')
      } catch (error) {
        console.error('Erro ao buscar padrinho:', error)
      }
    }

    const copyToClipboard = (text) => {
      navigator.clipboard.writeText(text).then(() => {
        proxy.$bvToast.toast('Link copiado!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
      }).catch(err => {
        console.error('Erro ao copiar o texto: ', err)
      })
    }

    onMounted(() => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchGrups`)
        .then(data => {
          data.grupos.map(grupo => {
            gruposOptions.value.push(grupo)
          })
        })

      fetchPadrinhoByUserId(userId)
        .then(response => {
        //   console.log('userId:', userId)
          console.log('Padrinho:', response.codigo)
        })
        .catch(error => {
          console.error('Erro ao buscar padrinho:', error)
        //   console.log('userId:', userId)
        })
    })

    return {
      idUsuario,
      addUsuario,
      blankUserData,
      editarUsuario,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      updatedStatusFilter,
      deletedUser,

      linkAfiliado,
      linkVendedor,
      showConviteModal,
      copyToClipboard,

      getRegisterBaseUrl,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>